import { render, staticRenderFns } from "./Results.vue?vue&type=template&id=76e582f6"
import script from "./Results.vue?vue&type=script&lang=js"
export * from "./Results.vue?vue&type=script&lang=js"
import style0 from "./Results.vue?vue&type=style&index=0&id=76e582f6&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76e582f6')) {
      api.createRecord('76e582f6', component.options)
    } else {
      api.reload('76e582f6', component.options)
    }
    module.hot.accept("./Results.vue?vue&type=template&id=76e582f6", function () {
      api.rerender('76e582f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Results.vue"
export default component.exports